import jQuery from 'jquery'
import 'lazysizes'
import 'lazysizes/plugins/bgset/ls.bgset'
import './assets/css/styles.pcss'
import './assets/ts/main.ts'

declare global {
  interface Window {
      $: JQueryStatic;
      jQuery: JQueryStatic;
  }
}

// ts-ignore
window.jQuery = jQuery
window.$ = jQuery
